export default __webpack_public_path__ + "static/media/Group9189.a2c6585f.svg";